/* global CKEDITOR */
/* eslint-disable new-cap */

import sessionReader from '../store/readHelpers/SessionReader';
import { t } from './i18nService';

const ckeditorService = {
    shouldForbidCopyPasteButtons() {
        return sessionReader.shouldDelegateClipboardClearingToIEP();
    },

    createForbidHandler(editorInstance, message, type = 'info') {
        return new CKEDITOR.command(editorInstance, {
            exec: (editor) => {
                const notification = new CKEDITOR.plugins.notification(editor, {
                    message,
                    type,
                    duration: 0,
                });
                notification.show();
            },
        });
    },

    forbidCopyPasteButtons(editorInstance) {
        const buttonsToForbid = [{
            command: 'copy',
            message: t('ckeditor.notification.forbidCopy'),
        }, {
            command: 'cut',
            message: t('ckeditor.notification.forbidCut'),
        }, {
            command: 'paste',
            message: t('ckeditor.notification.forbidPaste'),
        }];

        this.forbidToolbarButtons(editorInstance, buttonsToForbid);
    },

    forbidToolbarButtons(editorInstance, buttonsToForbid) {
        buttonsToForbid
            .filter(({ command }) => !!editorInstance.commands[command])
            .forEach(({ command, message }) => {
                const forbidHandler = this.createForbidHandler(editorInstance, message);
                editorInstance.commands[command].exec = forbidHandler.exec;
            });
    },
};

export default ckeditorService;
